exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row01-col-span-value{color:#54a0fb;font-size:18px}.row01-col-span-name{font-size:12px}.row01-col04{background-color:#54a0fb}.el-input__inner{height:25px}", ""]);

// exports
